module.exports = __webpack_public_path__ + "media/theme/ico-time-1-8ef461f8.png";